import { createApp, h } from "vue";
import router from "./router";
import i18n from "./plugins/i18n";
import App from "./App.vue";

createApp({
  render: () => h(App),
})
  .use(router)
  .use(i18n)
  .mount("#app-landing-vue");
